'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_ids$package$OrganizationId$() {
  this.aUf = null;
  this.aUg = false;
  this.aUj = null;
  this.aUk = false;
  this.aUl = null;
  this.aUm = false;
  this.aUh = null;
  this.aUi = false;
}
export { $c_Lapp_data_ids$package$OrganizationId$ as $c_Lapp_data_ids$package$OrganizationId$ };
$p = $c_Lapp_data_ids$package$OrganizationId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_ids$package$OrganizationId$;
/** @constructor */
function $h_Lapp_data_ids$package$OrganizationId$() {
}
export { $h_Lapp_data_ids$package$OrganizationId$ as $h_Lapp_data_ids$package$OrganizationId$ };
$h_Lapp_data_ids$package$OrganizationId$.prototype = $p;
$p.aC = (function() {
  if ((!this.aUg)) {
    this.aUf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeULID__circeCodec__Lio_circe_Codec(this);
    this.aUg = true;
  }
  return this.aUf;
});
$p.fI = (function() {
  if ((!this.aUk)) {
    this.aUj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeULID__tapirCodec__Lsttp_tapir_Codec(this);
    this.aUk = true;
  }
  return this.aUj;
});
$p.Ke = (function() {
  if ((!this.aUm)) {
    this.aUl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UrlConvertible$fromCodec(this.fI(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lurldsl_errors_DummyError$().sR());
    this.aUm = true;
  }
  return this.aUl;
});
$p.a5p = (function() {
  if ((!this.aUi)) {
    this.aUh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_Base64Id$().auo().bw("Organization ID");
    this.aUi = true;
  }
  return this.aUh;
});
var $d_Lapp_data_ids$package$OrganizationId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_ids$package$OrganizationId$, "app.data.ids$package$OrganizationId$", ({
  GM: 1,
  B: 1,
  C: 1,
  h8: 1
}));
export { $d_Lapp_data_ids$package$OrganizationId$ as $d_Lapp_data_ids$package$OrganizationId$ };
var $n_Lapp_data_ids$package$OrganizationId$;
function $m_Lapp_data_ids$package$OrganizationId$() {
  if ((!$n_Lapp_data_ids$package$OrganizationId$)) {
    $n_Lapp_data_ids$package$OrganizationId$ = new $c_Lapp_data_ids$package$OrganizationId$();
  }
  return $n_Lapp_data_ids$package$OrganizationId$;
}
export { $m_Lapp_data_ids$package$OrganizationId$ as $m_Lapp_data_ids$package$OrganizationId$ };
//# sourceMappingURL=app.data.ids$package$-Organization-Id$.js.map
